export {default} from './Channel';



// WEBPACK FOOTER //
// ./src/pages/Channel/index.ts